import { render, staticRenderFns } from "./EditManualCategory.vue?vue&type=template&id=00a3d444&scoped=true&"
import script from "./EditManualCategory.vue?vue&type=script&lang=js&"
export * from "./EditManualCategory.vue?vue&type=script&lang=js&"
import style0 from "./EditManualCategory.vue?vue&type=style&index=0&id=00a3d444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a3d444",
  null
  
)

export default component.exports